import { ApiErrorSchema } from './ApiErrorSchema';

export const commonResponses = {
  401: ApiErrorSchema,
  403: ApiErrorSchema,
  500: ApiErrorSchema,
};
